import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Eye = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 67 44" {...props}>
    <path
      d="M24.8 4.5C19.9 6.3 13.9 10.6 7 16.9L1.5 22l7 6.6c9.9 9.4 15 11.8 25 11.9 10 0 15.8-2.7 26-11.9l7-6.4-6.6-6.3C50.7 7 44.5 3.8 35.6 3.3c-4.5-.2-8.5.2-10.8 1.2zm21.7 3.8c2.8 1.4 7.7 5 11 8.1l6 5.6-5.9 5.5c-9.5 8.6-14.6 11-23.6 11-5.9 0-8.5-.5-12-2.4C17.3 33.7 5 23.4 5 22 5 20.2 19.7 8.9 24.5 7c6.7-2.7 15.2-2.2 22 1.3z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M29.1 10.7C18.9 16 19 28.2 29.3 33.3c6.5 3.3 14.5-.7 16.8-8.3 1-3.2.9-4.4-.7-7.6-3.5-7.1-10.3-9.8-16.3-6.7zM41.4 15c6.5 6.3 1.8 17.3-7.4 17.3-9.1 0-13.8-10.7-7.5-17.3 4.5-4.7 10-4.7 14.9 0z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M29 17c-4.3 4.3-1.1 12 5 12 3.8 0 7-3.2 7-7s-3.2-7-7-7c-1.7 0-3.9.9-5 2zm8.8 1.2c.7.7 1.2 2.4 1.2 3.8s-.5 3.1-1.2 3.8c-1.5 1.5-6.1 1.5-7.6 0s-1.5-6.1 0-7.6 6.1-1.5 7.6 0z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
